import { useModalStore } from '@/stores/apostatudo/modal';
import { useLoyaltyHubStore } from '@/stores/loyalty-hub';
import AnnouncementModal from '@/components/apostatudo/organisms/AnnouncementModal.vue';

// Bloqueia o acesso a /games e /sports (e subrotas) redirecionando pra home e
// reabrindo o popup de aviso. Abrir o popup direto pelo store garante feedback
// mesmo quando o usuário já está na home (navigateTo pra mesma rota é no-op e
// não remonta a página). Complemento do modo "site em ajustes".
// Só age com os jogos pausados no core (Operações do site, ENG-915).
export default defineNuxtRouteMiddleware((to, from) => {
  const { isGamesPaused } = useFeatureFlagsNew();

  if (!isGamesPaused.value) {
    return;
  }

  const blocked = ['/games', '/sports'];

  const isBlocked = blocked.some(
    (path) => to.path === path || to.path.startsWith(`${path}/`),
  );

  if (!isBlocked) {
    return;
  }

  if (import.meta.client) {
    const { open } = useModalStore();

    // O "USAR" do prêmio do check-in e da roletinha fecha só o próprio modal e
    // deixa o hub fechar no watch de rota dele. Na home, o redirect pra `/` não
    // muda a rota e o hub fica: sem `elevated` o aviso abriria atrás dele. Fora
    // da home a rota muda, o hub fecha sozinho, e a camada normal basta. (Os
    // cards do hub, o cashback e o post fecham o hub antes de navegar.)
    open(AnnouncementModal, {
      variant: 'games',
      elevated: useLoyaltyHubStore().isOpen && from.path === '/',
    });
  }

  return navigateTo('/');
});
